var $class="se2--content-lookup",$name="ContentLookup",$path="app/components/ContentLookup/index.js",$this={$class,$name,$path,};import 'app/partials/captcha';
import 'app/partials/checkbox';
import 'app/partials/formComponentWrapper';
import 'app/partials/input';
import 'app/partials/notification';
import 'app/partials/radioBtn';
import 'app/partials/select';
import 'app/partials/submit';
import 'app/partials/textarea';
import 'app/partials/snackbarComponent';

import ajax from 'app/modules/ajax';
import shell from 'app/modules/shell';
import analytics from 'app/modules/analytics';
import forEach from 'lodash/forEach';
import validateFormElements from 'app/components/utilities/validateFormElements';
import toggleSnackbarMessage from 'app/components/utilities/toggleSnackbarMessage';
import getCountryLanguageCodes from 'app/utilities/getCountryLanguageCodes';

// // region debug
// const mockedData = {
// "BfsStatus" : 200,
// "WarrantyStartDate" : "2020-09-04",
// "WarrantyEndDate" : "2023-09-03",
// "SerialNumber" : "3B2010X12863",
// "ExtendedWarrantyStartDate" : null,
// "ExtendedWarrantyEndDate" : null,
// "ProductSku" : null,
// "ProductName" : "BN1375M2",
// "ProductEntityList" : [
//  {
//   "SerialNumber" : "3B2010X12863",
//   "PartDescription" : "Job Mass Loaded on 13-FEB-2020 01:02:54 (server timezone)",
//   "PartName" : "BN1375M2"
// }
// ]
// };

// const fakeAjax = (success) => {
//   const promise = new Promise((resolve, reject) => {
//     if (success) setTimeout(() => resolve(mockedData), 500);
//     else setTimeout(() => reject(new Error()), 500);
//   });

//   return promise;
// };
// // endregion debug

export default shell.registerComponent($this, ({ addEventListener, publishMessage, configs, mount }) => {
  const warrantyLookUpClassName = 'warranty-lookup-form';
  const dateLookUpClassName = 'date-code-lookup-form';
  const submitButtonClassName = 'submit-btn';
  const inputFormFieldClassName = 'input-common';
  const additionalLinkClassName = 'additional-link';
  const resultCountClassName = 'result-count';
  const messageForInvalidRequest400ClassName = 'message-for-invalid-request-400';
  const messageForNoResult404ClassName = 'message-for-no-result-404';
  const messageForStatus207ClassName = 'message-for-status-207';
  const dateInfoClassName = 'date-info';
  const warrantyInfoClassName = 'warranty-info';
  const warrantyBlockClassName = 'warranty-block';
  const warrantyDateClassName = 'warranty-date';
  const eraseButtonClassName = 'button-close';
  const inputFieldClassName = 'input';
  const noDataElementClassName = 'no-info-text';
  const confirmationTextnoDataElementClassName = 'confirmation-text';
  const loaderClassName = 'se-loader';
  const snackBarContainerClassName = 'snackbar-container';

  const trackAnalytics = async (serialNumber) => {
    analytics.trackSearch({
      serialNumber,
    });
  };

  mount((element) => {
    const submitButtonElement = element.querySelector(`.${submitButtonClassName}`);
    const inputFormField = element.querySelector(`.${inputFormFieldClassName}`);
    const dateInfoElement = element.querySelector(`.${dateInfoClassName}`);
    const eraseButtonElement = element.querySelector(`.${eraseButtonClassName}`);
    const inputFieldElement = element.querySelector(inputFieldClassName);
    const additionalLinkElement = element.querySelector(`.${additionalLinkClassName}`);
    const resultCountElement = element.querySelector(`.${resultCountClassName}`);
    const messageForInvalidRequest400Element = element.querySelector(`.${messageForInvalidRequest400ClassName}`);
    const messageForNoResult404Element = element.querySelector(`.${messageForNoResult404ClassName}`);
    const messageForStatus207Element = element.querySelector(`.${messageForStatus207ClassName}`);
    const noDataElementElement = element.querySelector(`.${noDataElementClassName}`);
    const confirmationTextnoDataElement = element.querySelector(`.${confirmationTextnoDataElementClassName}`);
    const warrantyBlockElement = element.querySelector(`.${warrantyBlockClassName}`);
    const warrantyInfoElement = element.querySelector(`.${warrantyInfoClassName}`);
    const snackBarContainerElement = element.querySelector(`.${snackBarContainerClassName}`);

    const { countryCode, languageCode } = getCountryLanguageCodes(window.location.href);

    const fillData = (warrantyData) => {
      const updateField = (selectorName, value) => {
        if (value === null || value === undefined || value === '') {
          element.querySelector(`.${selectorName}`).innerText = '';
          element.querySelector(`.${selectorName}`)
            .closest(`.${warrantyInfoClassName}`)
            .classList.add(configs.css.classNames.hide);
          return;
        }

        (element.querySelector(`.${selectorName}`).innerText = value);
        element.querySelector(`.${selectorName}`)
          .closest(`.${warrantyInfoClassName}`)
          .classList.remove(configs.css.classNames.hide);
      };

      const updateProductEntityList = (productEntityList) => {
        if (productEntityList === null || productEntityList === undefined || !Array.isArray(productEntityList)
          || productEntityList.length === 0) {
          updateField('partName', null);
          return;
        }

        // Deliberately just take the first element of the array, even though there could be more elements in theory..
        const productEntity = productEntityList[0];

        updateField('partName', productEntity.PartName);
      };

      const showDataWhenProductEntitlyListPresent = () => {
        // Independently from BFS Status Code, show productEntity.PartName field if exists.
        if (warrantyData.ProductEntityList === null || warrantyData.ProductEntityList.length === 0) {
          return;
        }

        if (warrantyData.ProductEntityList != null && Array.isArray(warrantyData.ProductEntityList)
          && warrantyData.ProductEntityList[0].PartName != null) {
          warrantyBlockElement.classList.remove(configs.css.classNames.hide);
        }
      };

      updateField('warrantyStartDate', warrantyData.WarrantyStartDate);
      updateField('warrantyEndDate', warrantyData.WarrantyEndDate);
      updateField('extendedWarrantyStartDate', warrantyData.ExtendedWarrantyStartDate);
      updateField('extendedWarrantyEndDate', warrantyData.ExtendedWarrantyEndDate);
      updateProductEntityList(warrantyData.ProductEntityList);

      warrantyBlockElement.classList.remove(loaderClassName);
      warrantyBlockElement.querySelector(`.${warrantyInfoClassName}`).classList.remove(configs.css.classNames.hide);
      resultCountElement.classList.remove(configs.css.classNames.hide);

      showDataWhenProductEntitlyListPresent();
    };

    const cleanUpWarrantyData = () => {
      noDataElementElement.innerHTML = noDataElementElement.innerText
        .replace(/('')|("")|(" ")|(' ')|("[a-zA-Z0-9]{6,12}")/g, `"${inputFieldElement.value}"`);
      warrantyBlockElement.classList.remove(loaderClassName);
      confirmationTextnoDataElement?.classList.remove(configs.css.classNames.hide);
      warrantyBlockElement.classList.add(configs.css.classNames.hide);
      warrantyInfoElement?.classList.add(configs.css.classNames.hide);
      resultCountElement.classList.add(configs.css.classNames.hide);
    };

    const cleanUpWarrantyData400or404 = (data) => {
      cleanUpWarrantyData();
      if (data.BfsStatus === 400) {
        messageForInvalidRequest400Element?.classList.remove(configs.css.classNames.hide);
      }
      if (data.BfsStatus === 404) {
        messageForNoResult404Element?.classList.remove(configs.css.classNames.hide);
      }
    };

    const cleanUpResultsWhenServiceIsDown = () => {
      snackBarContainerElement?.classList.remove(configs.css.classNames.hide);
      additionalLinkElement.classList.add(configs.css.classNames.hide);
      warrantyBlockElement.classList.add(configs.css.classNames.hide);
      resultCountElement.classList.add(configs.css.classNames.hide);
      confirmationTextnoDataElement.classList.add(configs.css.classNames.hide);
      messageForNoResult404Element?.classList.add(configs.css.classNames.hide);
      messageForStatus207Element?.classList.add(configs.css.classNames.hide);
      messageForInvalidRequest400Element?.classList.add(configs.css.classNames.hide);
    };

    const fillWarrantyData = () => {
      additionalLinkElement?.classList.remove(configs.css.classNames.hide);
      messageForNoResult404Element?.classList.add(configs.css.classNames.hide);
      messageForInvalidRequest400Element?.classList.add(configs.css.classNames.hide);
      messageForStatus207Element?.classList.add(configs.css.classNames.hide);
      toggleSnackbarMessage('bg-error', false);

      const warrantyEndpoint = `/${countryCode}/${languageCode}/sdltfosvc/warranty/?sn=${inputFieldElement.value}`;

      ajax.fetchJSON(warrantyEndpoint)
        .then(((data) => {
          trackAnalytics(inputFieldElement.value);
          const extendedAndWarrantyDatesNotPresent = (!data.WarrantyStartDate && !data.WarrantyEndDate)
            && (!data.ExtendedWarrantyStartDate && !data.ExtendedWarrantyEndDate);

          // Display WarrantyStartDate, WarrantyEndDate,
          // ExtendedWarrantyStartDate and ExtendedWarrantyEndDate, if any exist, do not throw any error..
          if (!extendedAndWarrantyDatesNotPresent) {
            fillData(data);
            return true;
          }

          // 400 Status: Serial Number has incorrect format, according to the API.
          // 404 Status: Serial Number has has not been found, according to API.

          // Note: Browser already filters Serial Numbers which do not match 12 caracthers,
          // with 'warrantyPattern' regex expression in our code.
          // For better safty though, we additionally validate that format in the Back-end call as well.
          // If Back-end validation fails, 404 is being returned.
          if (data.BfsStatus === 400 || data.BfsStatus === 404) {
            cleanUpWarrantyData400or404(data);
            fillData(data);
            confirmationTextnoDataElement.classList.add(configs.css.classNames.hide);
            resultCountElement.classList.add(configs.css.classNames.hide);
            return true;
          }

          // Service is considered to be Down with Status Codes: 401, 403, 429 and 500 Range.
          const statusCodes = [401, 403, 429];
          if (statusCodes.includes(data.BfsStatus) || (data.BfsStatus >= 500 && data.BfsStatus <= 599)) {
            toggleSnackbarMessage('bg-error', true);
            cleanUpResultsWhenServiceIsDown();
            return true;
          }

          if (data.BfsStatus === 207) {
            fillData(data);

            // Only if all dates are null, display Error Message 207.
            if (extendedAndWarrantyDatesNotPresent) {
              messageForStatus207Element?.classList.remove(configs.css.classNames.hide);
              resultCountElement.classList.add(configs.css.classNames.hide);
            } else {
              resultCountElement.classList.remove(configs.css.classNames.hide);
            }
          }

          if (data.BfsStatus === 200) {
            fillData(data);
            return true;
          }

          const shouldFillData = !!(data.SerialNumber || data.serialNumber)
            || (data.ProductEntityList != null && Array.isArray(data.ProductEntityList)
              && data.ProductEntityList[0].SerialNumber != null);
          if (!shouldFillData) {
            cleanUpWarrantyData();
            return true;
          }
          return false;
        })).catch(() => {
          cleanUpWarrantyData();
          toggleSnackbarMessage('bg-error', true);
        });

      // fakeAjax(true, warrantyEndpoint).then(((data) => {
      //   if (!data.SerialNumber && !data.serialNumber) cleanUpWarrantyData();
      //   else {
      //     fillData(data);
      //   }
      // })).catch(() => cleanUpWarrantyData());
    };

    addEventListener(eraseButtonElement, 'click', () => {
      inputFieldElement.value = '';
      if (element.classList.contains(dateLookUpClassName)) {
        additionalLinkElement?.classList.add(configs.css.classNames.hide);
      }
      publishMessage(configs.messages.formSubmit, { status: 'accepted', formId: element.id, message: '' });
      element.reset();

      warrantyBlockElement.classList.add(configs.css.classNames.hide);
      resultCountElement.classList.add(configs.css.classNames.hide);
      confirmationTextnoDataElement?.classList.add(configs.css.classNames.hide);
      messageForNoResult404Element?.classList.add(configs.css.classNames.hide);
      messageForInvalidRequest400Element?.classList.add(configs.css.classNames.hide);
      messageForStatus207Element?.classList.add(configs.css.classNames.hide);
      snackBarContainerElement?.classList.add(configs.css.classNames.hide);
      toggleSnackbarMessage('bg-error', false);

      forEach(warrantyBlockElement.querySelectorAll(`.${warrantyInfoClassName}`),
        (el) => el.classList.add(configs.css.classNames.hide));
      forEach(warrantyBlockElement.querySelectorAll(`.${warrantyDateClassName}`),
        // eslint-disable-next-line no-return-assign
        (el) => el.innerText = '');
      submitButtonElement.setAttribute('disabled', 'disabled');
      eraseButtonElement?.classList.add(configs.css.classNames.hide);
    });

    const fillDateLookupData = (data) => {
      if (inputFieldElement.value >= 194871 && inputFieldElement.value <= 221343) {
        warrantyBlockElement.classList.remove(loaderClassName);
        warrantyBlockElement.classList.remove(configs.css.classNames.hide);
        resultCountElement.classList.remove(configs.css.classNames.hide);
        if (!confirmationTextnoDataElement.classList.contains(configs.css.classNames.hide)) {
          confirmationTextnoDataElement.classList.add(configs.css.classNames.hide);
          messageForNoResult404Element?.classList.remove(configs.css.classNames.hide);
          messageForInvalidRequest400Element?.classList.remove(configs.css.classNames.hide);
        }
        dateInfoElement.parentElement.classList.remove(configs.css.classNames.hide);
        dateInfoElement.innerHTML = dateInfoElement.innerText
          .replace(/('')|("")|(" ")|(' ')|("[0-9]{6}")/g, `"${inputFieldElement.value}"`);
        additionalLinkElement?.classList.remove(configs.css.classNames.hide);
      } else {
        if (!warrantyBlockElement.querySelector(`.${warrantyInfoClassName}`)
          .classList.contains(configs.css.classNames.hide)
        ) {
          warrantyBlockElement.querySelector(`.${warrantyInfoClassName}`).classList.add(configs.css.classNames.hide);
        }
        additionalLinkElement?.classList.add(configs.css.classNames.hide);
        cleanUpWarrantyData400or404(data);
      }
    };

    addEventListener(inputFormField, 'input', ({ target }) => {
      if (target.value === '') {
        eraseButtonElement?.classList.add(configs.css.classNames.hide);
        submitButtonElement.setAttribute('disabled', 'disabled');
      } else {
        eraseButtonElement?.classList.remove(configs.css.classNames.hide);
        submitButtonElement.removeAttribute('disabled');
      }
    });
    addEventListener(submitButtonElement, 'click', () => validateFormElements(element));
    addEventListener(element, 'submit', (e) => {
      e.preventDefault();
      if (!validateFormElements(element)) return false;

      warrantyBlockElement.classList.remove(configs.css.classNames.hide);
      warrantyBlockElement.classList.add(loaderClassName);

      if (element.classList.contains(warrantyLookUpClassName)) {
        fillWarrantyData();
      } else {
        fillDateLookupData();
      }

      return false;
    });
  });
});
